module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.backPages()
      }
    }
  }, [_vm._m(0)]), _vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ul', [_c('li', [_c('label', {
    attrs: {
      "for": "J_Phone"
    }
  }, [_vm._v("手机号码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.tel),
      expression: "user.tel"
    }],
    attrs: {
      "type": "text",
      "id": "J_Phone",
      "maxlength": "11",
      "placeholder": "请填写手机号码"
    },
    domProps: {
      "value": (_vm.user.tel)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Pwd"
    }
  }, [_vm._v("密码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "type": "password",
      "id": "J_Pwd",
      "maxlength": "16",
      "placeholder": "请填写密码"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('pwd')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "t-r"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.forgetPassword()
      }
    }
  }, [_vm._v("忘记密码")])])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "reg-link"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.registerUser()
      }
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow-left"
  }, [_c('div', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "btn"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "id": "J_LoginBtn",
      "value": "登录"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-280a94d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 189
// module chunks = 1